import styled from 'react-emotion'
import { mediaDn, spacer } from 'stylist'

const NavGrid = styled.nav`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  @supports (display: grid) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: ${spacer(4)} ${spacer(6)};

    ${mediaDn('lg')} {
      grid-template-columns: repeat(2, 1fr);
    }

    ${mediaDn('sm')} {
      grid-template-columns: 1fr;
    }
  }
`
export default NavGrid



// WEBPACK FOOTER //
// ./src/components/NavGrid.js